import axios from "axios";

// TODO: להחליף לדומיין הפרודקשן האמיתי כשיהיה קיים - כרגע אין עדיין שרת
// פרוד לפרויקט הזה, אז ברירת המחדל היא השרת המקומי (אותו BaseUrl בדיוק
// כמו client/functions/utils.js)
// const BaseUrl = `http://localhost:8082`;
// const BaseUrl = `https://unzere.vigler.com`
const BaseUrl = `https://e-gud.com`

const requestData = async (action, params) => {

    try {
        const appId = 1;
        let token = '';

        token = '';
        if (action !== 'BOSignIn') {
            token = localStorage.getItem("auth-token");
        }

        const now = new Date();
        const offsetMs = now.getTimezoneOffset() * 60000;
        const createAt = new Date(now - offsetMs).toISOString().slice(0, 19).replace('T', ' ');

        params = { ...params };

        const response = await axios.post(`${BaseUrl}/api/ver1/run`,
            { action, params },
            { headers: { token, appId, createAt } }
        );

        return response.data;
    } catch (error) {
        console.error("Error in axiosRequest:", error);
        throw error;
    }
};



// מעלה קובץ (תמונה/וידאו) שנבחר ב-<input type="file"> - קורא אותו כ-base64
// data URI בדפדפן ושולח ל-/api/file/upload (אותו endpoint שהאפליקציה משתמשת
// בו). folder נפרד לכל הקשר (למשל product-images) כדי שיהיה קל לאתר קבצים
// שהועלו מהבק אופיס.
const uploadFile = (file, folder = 'misc') => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async () => {
            try {
                const response = await axios.post(`${BaseUrl}/api/file/upload`, {
                    userId: 'backoffice',
                    base64Data: reader.result,
                    folder,
                });
                resolve(response.data);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
};

export default { requestData, uploadFile, BaseUrl };
